import { SeatDetail } from '@/src/types/itinerary'
import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { Typography } from '@mui/material'

import { Box } from '@mui/material'
import SeatItemWrapper from '../seatItem'

const SeatRow = ({
    rowIndex,
    rowId,
    rowCharacteristics,
    seatDetails,
    totalColumns,
    selectedSeatOptions,
    handleAddSeat,
    handleRemoveSeat,
    getSeatColor,
    formatCurrency
}: {
    rowIndex: number
    rowId: string
    rowCharacteristics: string
    seatDetails: SeatDetail[]
    totalColumns: number
    selectedSeatOptions: Partial<SeatDetail>[]
    handleAddSeat: (seat: SeatDetail) => void
    handleRemoveSeat: (seat: SeatDetail) => void
    getSeatColor: (price: number) => string
    formatCurrency: (price: number) => string
}) => {
    return (
        <Box key={rowIndex} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 0.6 }}>
            <Box
                sx={{
                    width: 36,
                    height: 32,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 700,
                        color: 'primary.main',
                        fontSize: 11
                    }}
                >
                    {rowId}
                </Typography>
            </Box>

            {/* Grid Cells */}
            {!isEmpty(seatDetails) && (
                <Box
                    key={rowIndex}
                    sx={{
                        display: 'flex',
                        gap: 1,
                        '&:dir(rtl)': {
                            flexDirection: 'row-reverse'
                        }
                    }}
                >
                    {Array.from({ length: totalColumns }, (_, columnIndex) => {
                        const seatCordinate = columnIndex + 1

                        const seat = seatDetails.find(seat => seat.seatCoordinates.yCoordinate === seatCordinate)

                        return (
                            <SeatItemWrapper
                                key={columnIndex}
                                seat={seat}
                                selectedSeatOptions={selectedSeatOptions}
                                rowCharacteristics={rowCharacteristics}
                                handleAddSeat={handleAddSeat}
                                handleRemoveSeat={handleRemoveSeat}
                                getSeatColor={getSeatColor}
                                formatCurrency={formatCurrency}
                            />
                        )
                    })}
                </Box>
            )}

            {/* Right Row Number - Styled like a seat block */}
            <Box
                sx={{
                    width: 36, // Wider than seat to accommodate double digits
                    height: 32, // Same height as seats

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 700,
                        color: 'primary.main',
                        fontSize: 11
                    }}
                >
                    {rowId}
                </Typography>
            </Box>
        </Box>
    )
}

export default SeatRow
